import { LinkText } from 'components/shared/LinkText';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { Heading2 } from '../../shared/Typography';
import {
  StyledCulture,
  StyledCultureTitle,
  StyledWhy
} from './JoinUsWhy.styled';

const JoinUsWhy: React.FC = () => {
  const { t } = useI18n('join-us');
  const { locale } = useRouter();

  return (
    <StyledWhy>
      <Heading2 editorial>{t('why.title')}</Heading2>

      <Trans
        ns={'join-us'}
        i18nKey={'why.desc'}
        components={{
          ethic: (
            <LinkText
              href={`${getAppUrl(
                APP_URLS.blog,
                locale
              )}/compromiso-etico-manfred`}
            />
          ),
          strong: <strong />,
          p: <p />
        }}
      />
      <StyledCulture>
        <img
          src={getPublicPath('/images/joinUs/nailted-badge.svg')}
          alt="Nailted badge"
        />
        <div>
          <StyledCultureTitle>{t('why.culture.title')}</StyledCultureTitle>
          <Trans
            ns={'join-us'}
            i18nKey={'why.culture.desc'}
            components={{
              nailtedLink: (
                <a
                  href={
                    locale === 'en'
                      ? 'https://nailted.com/employer-company-culture-advocate-badge '
                      : 'https://nailted.com/es/employer-company-culture-advocate-badge'
                  }
                />
              ),
              strong: <strong />,
              p: <p />
            }}
          />
        </div>
      </StyledCulture>
    </StyledWhy>
  );
};

export default JoinUsWhy;
